
				var addMethods = require("../../node_modules/workerize-loader/dist/rpc-wrapper.js")
				var methods = ["ws","send_message","close_ws"]
				module.exports = function() {
					var w = new Worker(__webpack_public_path__ + "4eb3cf2c9bf30d94c11e.worker.js", { name: "[fullhash].worker.js" })
					URL.revokeObjectURL(__webpack_public_path__ + "4eb3cf2c9bf30d94c11e.worker.js");
					addMethods(w, methods)
					
					return w
				}
			